import React from "react";
import { HotTable } from "@handsontable/react";
import { Pagination } from "zina-dogi-react";
import { utils } from "~/utils";

const SitesTable = ({ sites = [], status, pagination, ...others }) => {
    const data = getData(sites);
    const table_op = {
        width: "100%",
        height: 500,
        stretchH: "all",
        settings: {
            tableClassName: ["table", "table-bordered", "table-striped"],
            fillHandle: true,
            // disableVisualSelection: true,
            wordWrap: true,
            stretchH: "none",
            className: "htCenter htMiddle",
            colHeaders: getColHeaders(status),
            columns: getColumns(status),
            data
        }
    };
    return (
        <div>
            <HotTable {...others} {...table_op} />
            {pagination && <Pagination {...pagination} />}
        </div>
    );
};

const getColHeaders = () => [
    "Customer</br>Site Code",
    "Dummy Site </br>Id and Name",
    "Actual Site ID",
    "Site Address",
    "First delivery</br>address",
    "GPS Coordinates</br>Latitude",
    "GPS Coordinates</br>Longitude",
    "Remarks",
    "SAP WBS Region</br>Description",
    "SAP WBS Zone</br>Description",
    "Region",
    "SAP Modelsite</br>Template (Cost)",
    "Billing Milestone</br>Scheme",
    "Billing Milestone</br>Planned Dates",
    "SAP WBS</br>region code",
    "SAP WBS</br>zone code",
    "ZI partner</br>number",
    "Created site</br>WBS element"
];

const getColumns = status => {
    const is_editable = false;
    const res = [
        {
            data: "customer_site_code",
            editor: false,
            className: "htLeft htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "dummy_site_id",
            editor: false,
            className: "htLeft htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "actual_site_id",
            editor: false,
            className: "htLeft htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "site_address",
            editor: false,
            className: "htLeft htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "first_delivery_address",
            editor: false,
            className: "htLeft htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "gps_latitude",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "gps_longitude",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "remarks",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "sap_wbs_region_description",
            editor: false,
            className: "htLeft htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "sap_wbs_region_zone",
            editor: false,
            className: "htLeft htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "region",
            editor: false,
            className: "htLeft htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "sap_model_site_template",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "billing_milestone_scheme",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "billing_milestone_planned_dates",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "sap_wbs_region_code",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "sap_wbs_zone_code",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "zi_partner_number",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        },
        {
            data: "created_site_wbs_element",
            editor: false,
            className: "htRight htMiddle",
            ...(is_editable ? {} : { editor: false })
        }
    ];
    return res;
};

const getData = sites => {
    if (sites && sites.length > 0) {
        return sites.map(item => {
            const bms = item.billing_milestone_scheme;
            const bmpd = item.billing_milestone_planned_dates;
            return {
                ...item,
                billing_milestone_scheme: bms && bms !== "" ? bms : "",
                billing_milestone_planned_dates: utils.renderDate(bmpd)
            };
        });
    }
    return [{}];
};

export default SitesTable;
